'use strict';

var base = require('base/product/base');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
base.getPidValue = function ($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').data('pid') || $($el).closest('.product-set-detail').data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && $('.js-product-set-items').length ?
        $($el).closest('.product-detail').find('.quantity-select') :
        $('.quantity-select');
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
base.appendToUrl = function (url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
base.updateCartTotals = function (data) {

    if (data.queryString) {
        var id = data.queryString.split('&') ? data.queryString.split('&') : '';
        var product = id[0].split('=') ? id[0].split('=') : '';
        var selectedProduct = product[1] ? product[1] : '';
    }

    // set shipping cost in cart
    var isFreeShipping;
    var isFREEtext = $('.shipping-cost-for-free') ? $('.shipping-cost-for-free').text() : "";
    if (data.totals.subtotalvalue >= data.totals.offeredShippingMethodthreshold && data.shipments[0].selectedShippingMethod == data.offeredShippingMethod) {
        $('.shipping-cost').empty().html("<div class='bonus-product-bloc'><div class='bonus-produc-bloc-icon'></div><div class='bonus-produc-bloc-text'>" + isFREEtext + "</div></div>");
        isFreeShipping = true;
    } else {
        $('.shipping-cost').empty().append(data.totals.totalShippingCost);
        isFreeShipping = false;
    }

    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    if ($(".klarna-pdp").length) {
        $('.klarna-pdp').attr('data-purchase-amount', parseFloat(data.totals.grandTotalValue*100).toFixed(0));
        window.Klarna.OnsiteMessaging.refresh();
    }

    if (selectedProduct) {
        data.items.forEach(function (item) {
            if (item.id == selectedProduct) {
                $('.remove-line-item-button[data-pid="' + selectedProduct + '"]').data('price', item.priceTotal.price);
                $('.remove-line-item-button[data-pid="' + selectedProduct + '"]').data('nonadjustedprice', item.priceTotal.nonAdjustedPrice);
                $('.remove-line-item-button[data-pid="' + selectedProduct + '"]').data('qty', item.quantity);
            }
        });
    }


    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0 && !isFreeShipping) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
        $('.shipping-delivery-price').addClass('FREE-shipping-discount');
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
        $('.shipping-delivery-price').removeClass('FREE-shipping-discount');
    }
    if (isFreeShipping) {
        $('.shipping-delivery-price').addClass('FREE-shipping-discount');
    }

    data.items.forEach(function (item) {
        $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
}

base.updateSamplesNumber = function (data) {
    $('.number-items-samples').empty().html(data.resources.numberOfItemsMsg);
    $('.number-items-samples').append('<span aria-hidden="true" title="icon basket" class="icon icon-chevron-thin-right"></span>')
    $('#NumberSamples').empty().html(data.numberOfSamples);
    $('.samples-list .sample-input').each(function () {
        $(this).removeAttr('disabled');
        $(this).parents('.samples-cart-element').removeClass('sample-disabled');
        // Only uncheck if necessary
        if ($(this).prop('checked')) {
            $(this).prop('checked', false);
            $(this).trigger("change");
        }
    });
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
base.updateApproachingDiscounts = function (approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}


/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */

base.updateAvailability = function (data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += '<p class="line-item-attributes line-item-instock-date">'
                + lineItem.availability.inStockDate
                + '</p>';
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);
}


/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
base.validateBasket = function (data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart .popover').empty();
            $('.minicart .popover').hide();
            $('.mini-cart-overlay').hide();
        }
    }
}


/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
base.createErrorNotification = function (message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValues(attr, $productContainer) {
    $productContainer.find('.js-dialog .js-variation-selector-button.selected').removeClass('selected');
    $productContainer.find('.js-attribute-shades-list .js-variation-selector-button.selected').removeClass('selected');

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.parents('.js-attribute-shades-list').toggleClass('space-tag', $attrValue.hasClass('has-tag'));
            $attrValue.closest('.js-attribute-shades-list').toggleClass('space-tag', $attrValue.hasClass('has-tag'));
            processColorSelectorDialogOpenButton(attrValue, $productContainer)
        } else {
            $attrValue.removeClass('selected');
        }
    });
}

function processColorSelectorDialogOpenButton(attrValue, $productContainer ) {
    let variationSelector = '.js-color-selector-dialog-open-button:not(.js-color-selector-dialog-open-button--mini)';
    const buttonContent =
        (attrValue.CORE_shade_number ? attrValue.CORE_shade_number + ' - ' : '') +
        attrValue.displayValue +
        (attrValue.CORE_shade_informations ? '<span class="core-shade-informations"> - ' + attrValue.CORE_shade_informations + '</span>' : '');

    if(isGoesWellSection($productContainer)) {
        variationSelector = '.js-color-selector-dialog-open-button.js-color-selector-dialog-open-button--mini'
    }

    $(variationSelector).find('.js-variation-selector-color').css('background-color', attrValue.CORE_single_shade_hexa_code);

    $(variationSelector).find('.js-variation-selector-label').html(buttonContent);
}


/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processNonSwatchValues(attr, $productContainer, msgs) {
    var $defaultOption = $productContainer.find('#pdp-capacity-selector' + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $('#pdp-capacity-selector' + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('href', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }

        if ($('#capacitymodify')) {
            if (attrValue.selected) {
                $attrValue.addClass('selected');
                $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            } else {
                $attrValue.removeClass('selected');
                $attrValue.siblings('.selected-assistive-text').empty();
            }
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {

        if (attrsWithSwatches.indexOf(attr.id) > -1 && attr.id === 'color') {
            processSwatchValues(attr, $productContainer);
        } else {
            processNonSwatchValues(attr, $productContainer, msgs);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<div>' + response.resources.info_selectforstock + '</div>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<div>' + message + '</div>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getProductAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attribute, i) {
        var attributeResult = attribute.value;

        if (i !== (attributes.length - 1)) {
            attributeResult = attributeResult + ', ';
        }
        html += attributeResult;
    });

    return html;
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': ' +
                    attribute.value + '</div>';
            });
        }
    });

    return html;
}

function updatePrimaryImages(response, $productContainer) {
    const primaryImageUrls = response.product.images['large'];
    primaryImageUrls.forEach(function (imageUrl, idx) {
        $productContainer.find('.js-pdp-primary-images-link').eq(idx)
            .attr('href', imageUrl.url)
            .html( `<img class="responsive-img pdp-primary-images__img" src='${imageUrl.url}' decoding="async" alt="${response.product.productName}" />`);
        $productContainer.find('.js-pdp-primary-gallery-image').eq(idx)
            .html( `<img class="responsive-img pdp-primary-gallery__image js-pdp-primary-gallery-image" src='${imageUrl.url}' decoding="async" alt="${response.product.productName}" />`);

    })
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    if ($('.js-product-set-item').length) {
        // Ignore rest of code for product set
        return;
    }

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));

    //Update MUFE product attributes

    $('.product-attributes').empty().html(getProductAttributesHtml(response.product.allAttributes));
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    var optionsHtml;
    if (!($productContainer.parent('.bonus-product-item').length > 0) && quantities.length > 0) {
        optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    } else {
        optionsHtml = () => {
            return '<option value="1"  data-url="" selected>' + 1 + '</option>';
        }
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Update In Stock! Alert
 */

function updateInStockAlert(data) {
    if (!data.product.minStock && data.product.readyToOrder && data.product.available) {
        $('.js-alert-product').hide();
    } else {
        $('.js-alert-product').show();
    }
}

function updateBadgeDisplay(product) {
    var $productBadge = $(".pdp-badge");

    if (product.productTag && !$productBadge.length) {
        $(".promo-name-badge").append("<div class='pdp-badge'>" + product.productTag + "</div>")
    } else if (!product.productTag && $productBadge.length) {
        $productBadge.remove();
    } else if (product.productTag && $productBadge.length) {
        $productBadge.text(product.productTag);
    }
}

/**
 *
 * @param {Object} product - Product object
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function updateSetInformation(product, $productContainer) {
    // Update set id & availability
    $productContainer.find('.js-product-set-item-image').attr('src', product.images.small[0].url);
    $productContainer.attr('data-pid', product.id);
    $productContainer.attr('data-availability', !product.minStock && product.readyToOrder && product.available);
}

/**
 * Disable/enable add to cart button product set
 */
function updateSetAddToCartBtn(data) {
    const isProductSetAvailable = $('.js-product-set-item[data-availability=false]').length === 0;
    const addToCartText = isProductSetAvailable ? data.resources.inStock : data.resources.outOfStock
    $('.js-add-to-cart-button').attr('disabled', !isProductSetAvailable);
    $('.js-add-to-cart-button-price').toggleClass('hidden', !isProductSetAvailable);
    $('.js-add-to-cart-button-divider').html(addToCartText);
}

/**
 * Update add to cart button background-color variable
 */
// Reverted. The accessibility is a issue for dark shades.TODO: update the function with a script to calculate the contrast.
// function updateAddToCartBackgroundColor(color) {
//     $('.js-add-to-cart-button').css('--selected-shade-color', color);
// }

/**
 * Show/hide product set availability message.
 * @param {Object} product - Product object
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function updateSetAvailabilityMsg(product, $productContainer) {
    $productContainer.find('.js-product-set-item-availability').toggleClass('hidden', product.available);
}

/**
 * Check if there is a call from the "Goes well" section
 * @param {jQuery} $productContainer - DOM element for a given product.
 * return boolean
 */
function isGoesWellSection($productContainer) {
    return $productContainer.hasClass('js-goes-well');
}

/**
 * Updates Add to cart button post Ajax call
 * @param {Object} data - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */

function updateAddToCartStatus(data, $productContainer) {
    const isProductAvailableToSell = data.product.available && !data.product.minStock && data.product.readyToOrder;
    const addToCartDividerText = isProductAvailableToSell ? data.resources.inStock : data.resources.outOfStock;
    const $addToCartButton = $productContainer.find('.js-add-to-cart-button');
    const $addToCartDivider = $addToCartButton.find('.js-add-to-cart-button-divider');

    if ($addToCartDivider.length > 0) {
        $addToCartDivider.html(addToCartDividerText);
    } else {
        $addToCartButton.prepend('<span class="add-to-cart-divider js-add-to-cart-button-divider">' + addToCartDividerText + '</span>');
        $addToCartButton.find('.js-add-to-cart-button-price').toggleClass('hidden', !isProductAvailableToSell);
    }
    // Update data-pid
    $addToCartButton.attr('data-pid', data.product.id);
    $productContainer.attr('data-pid', data.product.id);

    // Disable/enable the add to cart button
    $addToCartButton.attr('disabled', !isProductAvailableToSell);

    // Update pricing
    let $priceSelector = $('.prices:not(.js-goes-well-prices) .price', $productContainer);
    if (isGoesWellSection($productContainer)) {
        $priceSelector = $('.prices.js-goes-well-prices .price', $productContainer)
    }

    $priceSelector.replaceWith(data.product.price.html);
}

/**
 * Updates Add to cart button post Ajax call
 * @param {Object} data - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */

function updateProductInfoMini(data, $productContainer) {
    const isProductAvailableToSell = data.product.available && !data.product.minStock && data.product.readyToOrder;
    const $addToCartButton = $productContainer.find('.js-add-to-cart-button-goes-well');
    const $priceSelector = $('.prices.js-goes-well-prices .price', $productContainer)

    var image = data.product.images.small[0].url;
    if (data.product.images.medium != null) {
        image = data.product.images.medium[0].url;
    }

    $productContainer.find('.js-product-tile-image-container img').attr('src', image); // Update "goes well" section image
    $productContainer.find('.js-add-to-cart-button-goes-well').attr('data-pid', data.product.id); // Update product ID for "goes well" section Add to cart button
    $addToCartButton.attr('disabled', !isProductAvailableToSell); // Disable/enable the add to cart button
    $priceSelector.replaceWith(data.product.price.html2);  // Update pricing
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueData, $productContainer) {

    if (selectedValueData.url) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueData.url,
            container: $productContainer
        });

        $.ajax({
            url: selectedValueData.url,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);

                if (isGoesWellSection($productContainer)) {
                    updateProductInfoMini(data, $productContainer);
                } else {
                    updatePrimaryImages(data, $productContainer);

                    if ($('.js-product-set-item').length) {
                        updateSetInformation(data.product, $productContainer);
                        updateSetAvailabilityMsg(data.product, $productContainer);
                        updateSetAddToCartBtn(data);
                    } else {
                        updateQuantities(data.product.quantities, $productContainer);
                        updateAddToCartStatus(data, $productContainer);
                        // updateAddToCartBackgroundColor(selectedValueData.colorHexa); // Reverted. The accessibility is a issue for dark shades.TODO: update the function with a script to calculate the contrast.
                        updateInStockAlert(data);
                        updateBadgeDisplay(data.product);
                    }
                }

                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer
                });

                if ($('.productDataGTM').length) {
                    var productDataGTM = $('.productDataGTM').val();
                    productDataGTM = JSON.parse(productDataGTM);
                    var variantName = '';
                    var productData= data.product.variantList;
                    for (let index = 0; index < productData.length; index++) {
                        const element = productData[index];
                        if (element.prodID == data.product.id) {
                            variantName = element.customDescription;
                            break;
                        }
                    }
                    dataLayer.push({
                        'event':'product_page',
                        'ecommerce': {
                            'detail': {
                                'products': [{
                                    name: data.product.productName,
                                    id: data.product.id,
                                    price: data.product.price.sales.value,
                                    brand: data.product.brand,
                                    category: productDataGTM['category'],
                                    variant: variantName,
                                    dimension17: productDataGTM['dimension17']
                                }]
                            }
                        },
                    });
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade" id="chooseBonusProductModal" role="dialog">' +
        '<div class="modal-dialog choose-bonus-product-dialog" ' +
        'data-total-qty="' + data.maxBonusItems + '"' +
        'data-UUID="' + data.uuid + '"' +
        'data-pliUUID="' + data.pliUUID + '"' +
        'data-addToCartUrl="' + data.addToCartUrl + '"' +
        'data-pageStart="0"' +
        'data-pageSize="' + data.pageSize + '"' +
        'data-moreURL="' + data.showProductsUrlRuleBased + '"' +
        'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <span class="">' + data.labels.selectprods + '</span>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">&times;</button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'html',
        success: function (html) {
            var parsedHtml = parseHtml(html);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return {
        body: body,
        footer: footer
    };
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }

    // Keep this code for minicart evolution
    // else {
    //     var messageType = response.error ? 'alert-danger' : 'alert-success';
    //     if ($('.add-to-cart-messages').length === 0) {
    //         $('body').append(
    //             '<div class="add-to-cart-messages"></div>'
    //         );
    //     }

    //     $('.add-to-cart-messages').append(
    //         '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
    //         + response.message
    //         + '</div>'
    //     );

    //     setTimeout(function () {
    //         $('.add-to-basket-alert').remove();
    //     }, 5000);
    // }
}

base.addToCart = function () {
    $(document).on('click', '.js-add-to-cart-button, .js-add-to-cart-button-goes-well', function () {
        let addToCartUrl =  getAddToCartUrl();
        let pid;
        let pidsObj;

        $('body').trigger('product:beforeAddToCart', this);

        if($(this).closest('.js-product-details-section-set').length > 0) { // Product set add to cart has been pushed
            let setPids = [];
            $('.js-product-set-item').each(function () {
                setPids.push({
                    pid: $(this).attr('data-pid'),
                    qty: '1',
                    options: getOptions($(this))
                });
            });
            pidsObj = JSON.stringify(setPids);
        } else {
            pid = $(this).attr('data-pid');
        }

        let $productContainer = $(this).closest('.product-detail, .product-set-detail');

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: base.getQuantitySelected($(this)) || '1'
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $.spinner().stop();
                    base.miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

base.colorAttribute = function () {
    $(document).on('click', '.js-variation-selector-button', function (e) {
        e.preventDefault();
        const $targetButton = $(e.target).closest('.js-variation-selector-button');
        const isTargetButtonSelected = $targetButton.hasClass('selected');

        if (isTargetButtonSelected) return;

        const targetButtonData = $targetButton.data();

        let $productContainer = $(this).closest('.js-product-set-item'); // Product set container

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.js-goes-well'); // Mini(goes well section) container
        }

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail'); // PDP container
        }

        if (!$productContainer.length) {
            $productContainer = $(this).closest('main').find('.product-detail');
        }

        attributeSelect(targetButtonData, $productContainer);

        // Check if the button is inside a dialog. Close the dialog, if yes.
        const $colorSelectorDialog = $targetButton.closest('.js-dialog')
        if ($colorSelectorDialog.length) {
            $colorSelectorDialog.find('.js-dialog-close-button').trigger('click');
        }

        //scroll to the top
        $('html, body').animate({ scrollTop: 0 }, 500);
    });

    $('.js-attribute-shades-list').each(function () {
        const $list = $(this);
        const $btnShade = $list.find('.js-variation-selector-button.selected');

        $list.toggleClass('space-tag', $btnShade.hasClass('has-tag'));
    });
};

base.enableBonusProductSelection = function () {
    $('body').on('bonusproduct:updateSelectButton', function (e, response) {
        $('button.select-bonus-product', response.$productContainer).attr('disabled',
            (!response.product.readyToOrder || !response.product.available || response.product.minStock));
        var pid = response.product.id;
        $('button.select-bonus-product', response.$productContainer).data('pid', pid);
    });
};

base.selectSize = function () {
    $(document).on('click', 'option.capacity-link', function () {
        let $productContainer = $(this).closest('.js-product-set-item, .product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('main').find('.product-detail');
        }
        attributeSelect($(this).attr('href'), $productContainer);
    });
};


base.basketQuantityChange = function () {
    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var bonusTemplate = $('#cart-page-container') && $('#cart-page-container').length > 0 ? "isCartBonusProduct" : "isMiniCartBonusProduct";

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid,
            bonusTemplate: bonusTemplate
        };
        url = base.appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {

                try {
                    if (data.productUpdateGtm) {
                        dataLayer.push(data.productUpdateGtm);
                    }
                } catch (e) {
                    console.log('Unable to trigger product update GTM data');
                }


                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                base.updateCartTotals(data);
                base.updateSamplesNumber(data);
                base.updateApproachingDiscounts(data.approachingDiscounts);
                base.updateAvailability(data, uuid);
                base.validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                var selector = $('ul.productlist-quantity');
                var bonusProduct = $('.bonus-product-line-item');
                $(bonusProduct).remove();
                $(selector).append(data.bonusHTML);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    base.createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });
}

base.basketRemoveProduct = function () {
    $('body').on('click', '.cart-delete-confirmation-btn', function () {
        // DUPLICATED FUNCITON, TO DO REMOVE
    });
}

base.addBonusProductsToCart = function () {
    $(document).on('click', '.add-bonus-products', function () {
        var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
        var queryString = '?pids=';
        var url = $('.choose-bonus-product-dialog').data('addtocarturl');
        var pidsObject = {
            bonusProducts: []
        };

        $.each($readyToOrderBonusProducts, function () {
            var qtyOption =
                parseInt($(this)
                    .data('qty'), 10);

            var option = null;
            if (qtyOption > 0) {
                if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                    option = {};
                    option.optionId = $(this).data('optionid');
                    option.productId = $(this).data('pid');
                    option.selectedValueId = $(this).data('option-selected-value');
                }
                pidsObject.bonusProducts.push({
                    pid: $(this).data('pid'),
                    qty: qtyOption,
                    options: [option]
                });
                pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
            }
        });
        queryString += JSON.stringify(pidsObject);
        queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
        queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
        $.spinner().start();
        $.ajax({
            url: url + queryString,
            method: 'POST',
            success: function (data) {
                $.spinner().stop();
                if (data.error) {
                    $('#chooseBonusProductModal').modal('hide');
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }
                    $('.add-to-cart-messages').append(
                        '<div class="alert alert-danger add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + data.errorMessage + '</div>'
                    );
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                    }, 3000);
                } else {
                    $('.configure-bonus-product-attributes').html(data);
                    $('.bonus-products-step2').removeClass('hidden-xl-down');
                    $('#chooseBonusProductModal').modal('hide');

                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }
                    $('.minicart-quantity').html(data.totalQty);
                    $('.add-to-cart-messages').html(
                        '<div class="alert alert-success add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + data.msgSuccess + '</div>'
                    );
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                        if ($('.cart-page').length) {
                            location.reload();
                        }
                    }, 1500);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

module.exports = base;